import { render, staticRenderFns } from "./SettingsVat.vue?vue&type=template&id=767fe63d&"
import script from "./SettingsVat.vue?vue&type=script&lang=js&"
export * from "./SettingsVat.vue?vue&type=script&lang=js&"
import style0 from "./SettingsVat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports